import styled from "styled-components";

export const Label = styled.label`
  font-size: 1rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;

export const Input = styled.input`

`;

export const ReadOnlyText = styled.p`
  margin: 0;
  font-size: 1rem;
`;

export const RedText = styled.span`
  font-size: 1.5em;
  color: #b00020;
`;